// extracted by mini-css-extract-plugin
export default {"Button":"AddButton_Button__2-4Td","Grow":"AddButton_Grow__XOgiA","Shrink":"AddButton_Shrink__URS08","Label":"AddButton_Label__ayjBL"};